import { Src } from './src';

const App = () => <Src />;

export default App;
